/**
 * Global shortcuts (doc 06 section 21): ⌘K / Ctrl+K command palette, ⌘N / Ctrl+N New Creative.
 * Spike S4: browsers may reserve ⌘N/Ctrl+N (new window) in a normal tab; the visible button and
 * ⌘K remain the guaranteed routes. `capturedNewCreative` records whether we got the event.
 */
import { useEffect } from "react";

export const isMac = () => /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

export function useGlobalShortcuts(handlers: { palette: () => void; newCreative: () => void }) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const mod = isMac() ? e.metaKey : e.ctrlKey;
      if (!mod || e.altKey || e.shiftKey) return;
      const key = e.key.toLowerCase();
      if (key === "k") {
        e.preventDefault();
        handlers.palette();
      } else if (key === "n") {
        e.preventDefault();
        (window as unknown as { __prismaShortcutN?: number }).__prismaShortcutN =
          ((window as unknown as { __prismaShortcutN?: number }).__prismaShortcutN ?? 0) + 1;
        handlers.newCreative();
      }
    }
    window.addEventListener("keydown", onKey, { capture: true });
    return () => window.removeEventListener("keydown", onKey, { capture: true });
  }, [handlers]);
}
